'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGroups$002dView$0024$0024anon$002415 from "./presto.-Groups-View$$anon$15.js";
import * as $j_presto$002etypes$0024$002dRole$0024 from "./presto.types$-Role$.js";
import * as $j_presto$002etypes$0024$002dRole$002dCode$0024 from "./presto.types$-Role-Code$.js";
import * as $j_presto$002etypes$0024$002dRole$002dId$0024 from "./presto.types$-Role-Id$.js";
import * as $j_presto$002etypes$0024$002dRole$002dName$0024 from "./presto.types$-Role-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupsView$$anon$14() {
  this.aWI = null;
  this.aWA = null;
  this.aWB = false;
  this.aWJ = null;
  this.aWK = false;
  this.aWN = null;
  this.aWG = null;
  this.aWH = false;
  this.aWC = null;
  this.aWD = false;
  this.aWE = null;
  this.aWF = false;
  this.aWL = false;
  this.aWM = false;
  this.aWI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aWN = "Role";
}
export { $c_Lpresto_GroupsView$$anon$14 as $c_Lpresto_GroupsView$$anon$14 };
$p = $c_Lpresto_GroupsView$$anon$14.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupsView$$anon$14;
/** @constructor */
function $h_Lpresto_GroupsView$$anon$14() {
}
export { $h_Lpresto_GroupsView$$anon$14 as $h_Lpresto_GroupsView$$anon$14 };
$h_Lpresto_GroupsView$$anon$14.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.aWI;
});
$p.L = (function() {
  if ((!this.aWB)) {
    this.aWA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aWB = true;
  }
  return this.aWA;
});
$p.O = (function() {
  if ((!this.aWK)) {
    this.aWJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aWK = true;
  }
  return this.aWJ;
});
$p.E = (function() {
  return this.aWN;
});
$p.t = (function() {
  if ((!this.aWH)) {
    this.aWG = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("deleted", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aWH = true;
  }
  return this.aWG;
});
$p.M = (function() {
  if ((!this.aWD)) {
    this.aWC = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRole$002dId$0024.$m_Lpresto_types$RoleId$().nL(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRole$002dCode$0024.$m_Lpresto_types$RoleCode$().kw(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRole$002dName$0024.$m_Lpresto_types$RoleName$().nM(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aWD = true;
  }
  return this.aWC;
});
$p.Q = (function() {
  if ((!this.aWF)) {
    this.aWE = new $j_presto$002e$002dGroups$002dView$0024$0024anon$002415.$c_Lpresto_GroupsView$$anon$15();
    this.aWF = true;
  }
  return this.aWE;
});
$p.w = (function() {
  if ((!this.aWM)) {
    this.aWL = false;
    this.aWM = true;
  }
  return this.aWL;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee209) => ((p) => \u03b4scrutinee209.nG(p)))($j_presto$002etypes$0024$002dRole$0024.$m_Lpresto_types$Role$())));
});
var $d_Lpresto_GroupsView$$anon$14 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupsView$$anon$14, "presto.GroupsView$$anon$14", ({
  Jv: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_GroupsView$$anon$14 as $d_Lpresto_GroupsView$$anon$14 };
//# sourceMappingURL=presto.-Groups-View$$anon$14.js.map
